import "core-js"
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import 'custom-event-polyfill'
import React from 'react'
import ReactDOM from 'react-dom'
import Router from './router/index.js'
import storeFactory from './store/index'
import { Provider } from 'react-redux'
import 'bootstrap/dist/css/bootstrap.min.css'
import './index.css'
import * as serviceWorker from './serviceWorker'

const store = storeFactory()

ReactDOM.render(
        <Provider store={store}>
            <Router />
        </Provider>
    , document.getElementById('root'));

serviceWorker.register();
